"use strict";
/*
 * Created on 11 28 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SimpleExportedEntityPublicConverter_1 = require("./SimpleExportedEntityPublicConverter");
/**
 * @author Jaroslav Sevcik
 */


var SimpleExportedEntityPublicConverterImpl =
/*#__PURE__*/
function (_SimpleExportedEntity) {
  _inherits(SimpleExportedEntityPublicConverterImpl, _SimpleExportedEntity);

  function SimpleExportedEntityPublicConverterImpl() {
    _classCallCheck(this, SimpleExportedEntityPublicConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SimpleExportedEntityPublicConverterImpl).apply(this, arguments));
  }

  _createClass(SimpleExportedEntityPublicConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      throw new Error('not-implemented');
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var document = {};
      Object.assign(document, conversions.classToDocumentId(source));
      Object.assign(document, {
        dataIdentifier: source.dataIdentifier,
        created: conversions.fromDate(source.created),
        fullPath: source.publicPath,
        deleted: source.deleted
      });
      return document;
    }
  }]);

  return SimpleExportedEntityPublicConverterImpl;
}(SimpleExportedEntityPublicConverter_1.SimpleExportedEntityPublicConverter);

exports.SimpleExportedEntityPublicConverterImpl = SimpleExportedEntityPublicConverterImpl;